/* @flow */
const pubSub = require("./pubsub");
const utils = require("./utils");
import { requestStats } from './storage/predict'


// new smart stats
let predictorFormats = {}
const parseStats = (base, stats) => {
    Object.keys(stats).forEach(statName => {
        if (statName[0] === '_') {
            return // ignore stats starting with underscore
        }
        let stat = stats[statName]
        if (stat.type === 'complex') {
            predictorFormats[statName] = stat.children[stat.defaultChild].unit
            parseStats( base ? `${base}:${statName}` : statName, stat.children)
        } else if (stat.type === 'categorical') {
            predictorFormats[base ? `${base}:${statName}` : statName] = '_categories'
        } else {
            predictorFormats[base ? `${base}:${statName}` : statName] = stat.unit
        }
        
    })
}
requestStats().then(stats => parseStats('', stats))

// set of parameters that use labels
const parameters = {
    home_value: '$',
    income: '$',
    rent: '$',
    renter_percentage: '%',
    work_commute_time: ' min',
    college_education: '%',
    cost_of_living: '%',
    house_age: 'y',
    welfare_percentage: '%',
    population_density: ' people/mi\u00b2',
    property_tax: '%',
    unemployment: '%',

    'urban_growth': '%',
    'metro_growth': '%',
    'region_growth': '%',
    '%': '%'
};

const isWhole = (unit: string): bool => {
    const wholeUnits = [
        'people',
        'households',
        'companies',
        'units',
        'rooms',
        'returns',
        'people/mi\u00b2',
    ]
    if (wholeUnits.includes(unit)) {
        return true;
    }
    return false
}
const standardize = (unit: string): string => {
    if (unit === 'ppl / sq. mi.') {
        return 'people/mi\u00b2'
    }
    return unit
}

class Tooltip {

    // make numerical value more human-friendly
    curateField(x: number, field: string, replace: Object): string {
        let format = predictorFormats[field] || parameters[field] || '';
        let mod = replace && replace[format] ? replace[format] : standardize(format)
        console.log("CURATE", x, field, format, mod)
        //            if %             then use % format      else if int        just stringify, else if > 100, use int, else use float
        let xOutput = format === '%' ? (x * 100).toFixed(2) : parseInt(x) == x ? x.toString() : isWhole(mod) ? parseInt(x).toString() : x.toFixed(2);
        let withCommas = xOutput.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (format === '$') {
            // put minus sign in front of dollar sign
            return withCommas[0] === '-' ? '-$' + withCommas.slice(1) : '$' + withCommas;
        } else if (format === 'year') {
            return xOutput;
        } else if (format === 'score' || format === 'index' || format === 'units') {
            return withCommas;
        } else {
            return withCommas + (format === '%'  ? '' : ' ') + mod;
        }
    }

    // curates every field of received data
    curateData(data: Object, c?: Controls): { [string]: string } {
        console.log("CURATE", data)
        let normalizedData = data
        let keys = Object.keys(data)
        let curatedFields: Object = {};

        Object.keys(data).forEach(field => {
            if (field[0] === '_') {
                return;
            }
            if (field === 'needLogin') {
                curatedFields.needLogin = 1
                return
            }
            let humanName = field !== 'title' && c ? (
                field.includes(':delta:') ? c.getStatControl(field.split(':delta:')[0]).humanFriendlyDeltaName : c.getStatControl(field).humanFriendlyName
                ) : utils.prettyName(field)
            // remove % from name, since it will already be mentioned in unit
            humanName = humanName.replace('% ', '')
            if (typeof data[field] === 'number') {
                curatedFields[humanName] = this.curateField(data[field], field);
            } else if (field === 'title') {
                curatedFields.title = data.title; // don't curate title
            } else if (data[field] && 'value' in data[field] && 'score' in data[field]) {
                // new predictor system
                if (data[field].score) {
                    curatedFields[humanName] = this.curateField(data[field].value, field)
                } else {
                    curatedFields[humanName] = 'No Data'
                }
            } else if (data[field] && !(data[field].score && 'value' in data[field])) {
                if (data[field].change && 'score' in data[field].change && 'value' in data[field].change) {
                    // new predictor system, delta
                    let years = Object.keys(data[field]).filter(k => k !== 'change')
                    humanName += ` (${years[0]}-'${years[1].slice(-2)})`
                    let diff = data[field][years[1]] - data[field][years[0]]
                    let delta = `${this.curateField(data[field].change.value, '%')} (${this.curateField(diff, field, { '%': ' pp' })})`
                    curatedFields[humanName] = delta
                } else {
                    // new predictor system, categories
                    let prefix = field.slice(0, field.lastIndexOf(':'))
                    Object.keys(data[field]).forEach(subfield => {
                        const item = data[field][subfield]
                        const value = item ? item.value : null
                        if (value && !isNaN(value)) {
                            let fullName = `${prefix}:${subfield}`
                            curatedFields[utils.prettyName(subfield)] = this.curateField(value, fullName)
                        }
                    })
                }
            }
        })
        return curatedFields;
    }
}

export default Tooltip;
